import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useProjectEdit } from '@/module/Author/Project/model/ProjectQuery';
import { ProjectSchema, defaultProjectValues, projectSchema } from '@/module/Author/Project/model/ProjectSchema';

import { useAppNotification } from '@feature/utils';

import { ProjectForm } from './ProjectForm';
import { Project } from './model/ProjectTypes';

interface ProjectEditProps {
  project: Project;
}

const convert = (project: Project): ProjectSchema => ({
  ...project,
});

export function ProjectEdit(props: ProjectEditProps) {
  const { project } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useProjectEdit(project.id);
  const notification = useAppNotification();

  const onSubmit = (values: ProjectSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(project), [project]);
  const navigate = useNavigate();

  return (
    <ProjectForm
      title={t('projects.form.title.edit')}
      schema={projectSchema}
      defaultValues={defaultProjectValues}
      values={values}
      onSubmit={onSubmit}
      isError={isError}
      isSuccess={isSuccess}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
